import React, {Component} from 'react';
import PropTypes from 'prop-types';
import send from '../../utils/ChatServer.js';
import userImage from '../../assets/128x128.jpg';
import {Link} from "react-router-dom";
import moment from 'moment';
import api from '../../utils/api';
import logo from "../../assets/img/logo-white.png";

/**
 * Site header.
 */

class ContentHeader extends Component {
    getUserImage = () => {

        if(this.props.user) {
            if(this.props.profile.image){
                return api.makeFileURL(this.props.profile.image, this.props.user.id);
            }else{
                return userImage;
            }

        }
    }
    //Renders
    renderLogo = () => (
        <Link
            to="/"
            className="logo"
        >
            <span className="logo-mini"><b><img src={logo} /></b></span>
        </Link>
    );

    renderMessagesMenu = (notifications) => {
        let seeAll = '/chat';
        if(this.props.user.user.Profile.role === 'admin'){
            seeAll = '/chat/admin/tickets';
        }else if(this.props.user.user.Profile.role === 'instructor'){
            seeAll = '/chat/tickets';
        }else{
            if(this.props.profile.CourseUser){
                if(this.props.profile.CourseUser.length > 0){
                    if(this.props.profile.CourseUser[0].currentSubject){
                        let t = this.props.threads.filter(t => !t.question && t.subjectId === this.props.profile.CourseUser[0].currentSubject);
                        if(t.length > 0){
                            seeAll = '/chat/' + t[0].id;
                        }
                    }
                }
            }
        }
        
        return (
            <li className="dropdown messages-menu">
                <a className="dropdown-toggle"
                   data-toggle="dropdown"
                >
                    <i className="zmdi zmdi-comment-text"/>
                    {this.props.threads.filter(t => t.unread > 0).length > 0 &&
                        <span className="label label-success">
                            {this.props.threads.filter(t => t.unread > 0).length}
                        </span>
                    }
                </a>
                <ul className="dropdown-menu pull-right">
                    <li className="header text-left">
                        You have {this.props.threads.filter(t => t.unread > 0).length} new messages
                    </li>
                    <li>
                        <div className="slimScrollDiv">
                            <ul className="menu">
                                {
                                    this.props.threads
                                    && this.props.threads.length > 0
                                    && this.renderMessagesList()
                                }
                            </ul>
                            <div className="slimScrollBar"/>
                            <div className="slimScrollRail"/>
                        </div>
                    </li>
                    <li className="footer">
                        <Link to={seeAll}>See All Messages</Link>
                    </li>
                </ul>
            </li>
        )
    }

    renderMessagesList = () => {
        return this.props.threads.map((t, i) => {
            
            if(t.Profiles || t.title === 'announcements' || t.subjectId){
                
                if(t.title === 'announcements'){
                    
                    return null
                    
                }else if(t.subjectId && this.props.courseUser){
                    let bg = 0;
                    let cu = this.props.courseUser[0];
                    if(cu.id){
                        if(cu.Course){
                            cu.Course.CourseSubject.map((s, i) => s.id === t.subjectId ? bg = i : bg = 0);
                        }
                        
                    }
                     return (
                        <li className={`${t.unread > 0 ? 'unread' : ''}`} key={i}>
                            <Link to={`/chat/${t.id}`}>
                                <div className="pull-left">
                                   
                                    
                                 <span className={`chat-subject-icon bg-sub-${bg}`}>{t.Subject ? t.Subject.name[0] : ''}</span>
                                </div>
                                {t.Messages ? 
                                    t.Messages.length > 0 ?
                                    <span>
                                        <h4>
                                            {t.Subject ? t.Subject.name : ''}
                                            <small>
                                                <i className="fa fa-clock-o"/>
                                                {moment(t.Messages[t.Messages.length - 1].createdAt).fromNow() || ''}
                                            </small>
                                        </h4>
                                        <p>
                                            {t.Messages[t.Messages.length - 1].content.replace('{name}', this.props.user.user.Profile.name)}
                                        </p>
                                        {t.unread > 0 &&
                                                        <span class="label label-info unread-count">{t.unread}</span>
                                                    }
                                    </span>
                                :
                                
                                t.question &&
                                    <span>
                                            <h4>
                                                {t.Subject ? t.Subject.name : ''}
                                                <small>
                                                    <i className="fa fa-clock-o"/>
                                                    {''}
                                                </small>
                                            </h4>
                                            <p>
                                                {t.question}
                                            </p>
                                            {t.unread > 0 &&
                                                        <span class="label label-info unread-count">{t.unread}</span>
                                                    }
                                        </span>
                                : null}
                            </Link>
                        </li>
                    )
                }else{
                    let profile = t.Profiles.filter(p => p.id !== this.props.user.user.Profile.id)[0];
                    if(profile){
                        if(t.Messages){
                            if(t.Messages.length > 0){

                                return (
                                    <li className={`${t.unread > 0 ? 'unread' : ''}`} key={i}>
                                        <Link to={`/chat/${t.id}`}>
                                            <div className="pull-left">
                                               
                                                
                                                {profile.image ?
                                                    <span>
                                                        {profile.image.indexOf('http') === -1 ?
                                                            <img src={api.makeFileURL(profile.image) || userImage} className="img-circle"
                                                    alt="User" />
                                                        :
                                                            <img src={(profile.image) ? profile.image : userImage} className="img-circle"
                                                    alt="User" />
                                                        }
                                                    </span>
                                                    
                                                    :
                                                    <img src={(profile.image) ? profile.image : userImage} className="img-circle"
                                                    alt="User" />
                                                }
                                            </div>
                                            <h4>
                                                {profile.name}
                                                <small>
                                                    <i className="fa fa-clock-o"/>
                                                    {moment(t.Messages[t.Messages.length - 1].createdAt).fromNow() || ''}
                                                </small>
                                            </h4>
                                            <p>
                                                {t.Messages[t.Messages.length - 1].content.replace('{name}', this.props.user.user.Profile.name)}
                                            </p>
                                            {t.unread > 0 &&
                                                        <span class="label label-info unread-count">{t.unread}</span>
                                                    }
                                        </Link>
                                    </li>
                                )                
                            }
                        }
                    }
                }
            }
            
        })
        
        /*
        return this.props.notifications.map((message, index) => (
                <li key={index}>
                    <a>
                        <div className="pull-left">
                            <img
                                src={message.photo}
                                className="img-circle"
                                alt="User"
                            />
                        </div>
                        <h4>
                            {message.name}
                            <small>
                                <i className="fa fa-clock-o"/>
                                {message.time}
                            </small>
                        </h4>
                        <p>
                            {message.text}
                        </p>
                    </Link>
                </li>
            )
        );
        */
    };

    renderTasksMenu = (tasksProgress) => {
        let {tasks} = this.props;
        if(tasks){
            return (
                <li className="dropdown tasks-menu">
                    <a
                        className="dropdown-toggle"
                        data-toggle="dropdown">
                        <i className="fa fa-flag"/>
                        {this.props.tasks.filter(t => t.progress < 100 && moment().diff(moment(moment(t.date).format('MM/DD/YYYY')), 'days') === 0).length > 0 &&
                            <span className="label label-danger">
                                {this.props.tasks.filter(t => t.progress < 100 && moment().diff(moment(moment(t.date).format('MM/DD/YYYY')), 'days') === 0).length}
                            </span>
                        }
                    </a>
                    <ul className="dropdown-menu pull-right">
                        <li className="header">
                            You have {this.props.tasks.filter(t => t.progress < 100 && moment().diff(moment(moment(t.date).format('MM/DD/YYYY')), 'days') === 0).length} task{this.props.tasks.filter(t => t.progress < 100 && moment().diff(moment(moment(t.date).format('MM/DD/YYYY')), 'days') === 0).length > 1 ? 's' : ''}
                        </li>
                        <li>
                            <div className="slimScrollDiv">
                                <ul className="menu">
        
                                    {
                                        tasksProgress
                                        && tasksProgress.length > 0
                                        && this.renderTasksList()
                                    }
        
                                </ul>
                                <div className="slimScrollBar"/>
                                <div className="slimScrollRail"/>
                            </div>
                        </li>
                        <li className="footer">
                            <Link to="/tasks">View all tasks</Link>
                        </li>
                    </ul>
                </li>
            )
        }else{
            return null;
        }
    }
    
    completeTask = (taskId) => {
        let task = this.props.tasks.filter(task => task.id === taskId);
        if(task.length > 0){
            task = task[0];
            task.progress = 100;
            let command = {
                type: 'UPDATE_TASK',
                task: task,
                profileId: this.props.profile.id
            };
            
            send(command, this.props.socket, this.props.user.id);
    
            
            //NotificationManager.success("Task complete!  Great job!");
        }
    }

    renderTasksList = () => (
         this.props.tasks.filter(t => t.progress < 100 && moment().diff(moment(moment(t.date).format('MM/DD/YYYY')), 'days') === 0).map((task, index) => {
            if (task.value.length > 0) {
                let cu = this.props.courseUser.filter(c => c.id === task.courseUserId)[0];
                let link = '#';
                if(cu){
                    if(task.value[task.currentIndex]){
                        if(task.value[task.currentIndex].test){
                            link = '/subject-test/' + task.value[task.currentIndex].value;
                        }else{
                            if(cu.status === 'approved'){
                                link = '/video/item/' + task.value[task.currentIndex].value;
                            }
                        }
                    }
                }
                
                let color = task.progress < 50 ? 'progress-bar-warning' : 'progress-bar-info';
                let width = task.progress ? task.progress : 0;
                return (
                    <li key={index}>
                        <Link to={link}>
                            <h3>
                                {task.title}
                                <small className="pull-right">
                                    {task.progress}%
                                </small>
                            </h3>
                            
                            <div className="progress xs">
                                <div
                                    className={`progress-bar ${color}`}
                                    style={{"width": (width).toString() + '%'}}
                                    role="progressbar"
                                    aria-valuenow={width}
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                >
                                    <span className="sr-only">
                                        {width}% Complete
                                    </span>
                                </div>
                            </div>
                            
                        </Link>
                    </li>
                )
            } else {
                return (
                    <li key={index}>
                        <Link to={`${task.generated ? '/dashboard' : '#'}`}>
                            <h3>
                                {task.title}
                                {!task.generated &&
                                <small className="pull-right">
                                    {task.progress}
                                </small>
                                }
                            </h3>
                        </Link>
                    </li>
                )
            }
         })
     );

    renderUserMenu = (user, onLogout) => {
        
        return (
            <ul className="nav navbar-nav">
                <li className="dropdown user-nav-right-side">
                    <Link to="#" className="dropdown-toggle" data-toggle="dropdown" aria-expanded="true">
                        <div className="initials">
                            {this.props.profile.name ? this.props.profile.name[0] : '99'}
                            {this.props.profile.lname ? this.props.profile.lname[0] : ''}
                        </div>
                    </Link>
                    <ul className="dropdown-menu pull-right">
                        <li><Link to="/"><i className="zmdi zmdi-library" /> &nbsp; My Courses</Link> </li>
                        {this.props.profile ?
                            this.props.profile.role === 'student' ?
                                <li><Link to="/dashboard" onClick={e => {
                                    let {profile} = this.props;
                                    e.preventDefault();
                                    profile.tourComplete = false;
                                    this.props.takeTour(profile, this.props.user.id);
                                    
                                    this.props.history.push('/dashboard');
                                }}><i className="zmdi zmdi-view-carousel" /> &nbsp; Take Tour</Link></li>
                            : null
                        : null}
                        <li><Link to="/settings"><i className="zmdi zmdi-settings" /> &nbsp; Settings</Link> </li>
                        {this.props.courseUser ?
                        <li><Link to={`/logs/${this.props.courseUser[0] ? this.props.courseUser[0].id : ''}`}><i className="zmdi zmdi-eye" /> &nbsp; History</Link> </li>
                        : null}
                        {/*<li><Link to="#about" data-toggle="modal"><i className="zmdi zmdi-info-outline" /> &nbsp; About</Link> </li>*/}
                        <li><Link to="/login"
                        onClick={(e) => {
                            e.preventDefault();
                            window.localStorage.clear();
                            onLogout();
                        }}><i className="zmdi zmdi-power" /> &nbsp; Sign Out</Link> </li>
                    </ul>
                </li>    
            </ul>
        )
    }
        

    //LifecycleMethods
    componentDidMount() {
        this.props.onNotificationsLoad();
        this.props.onTaskProgressLoad();
    }

    render() {
        const {
            notifications,
            tasksProgress,
            user,
            onLogout,
            onSidebarToggleCollapse
        } = this.props;
        return (
            <header className="main-header">
                
                <nav
                    className="navbar navbar-static-top"
                    role="navigation"
                >
                {this.renderLogo()}
                    {/*
                    <Link
                        to="#"
                        className="zmdi zmdi-more-vert"
                        data-toggle="offcanvas"
                        role="button"
                        onClick={(e) => {
                            e.preventDefault();
                            onSidebarToggleCollapse();
                        }}
                    >
                    </Link>
                    */}
                    <div className="navbar-custom-menu">
                        <div className="navbar-left">
                            {this.props.user.user.emailVerified &&
                            <ul className="nav navbar-nav">
                                {this.props.threads ? this.props.courseUser ? this.renderMessagesMenu(notifications) : null : null}
                                {this.props.courseUser ? this.renderTasksMenu(tasksProgress) : null}
                            </ul>
                            }
                        </div>
                        {this.renderUserMenu(user, onLogout)}
                    </div>
                </nav>
            </header>
        )
    }
}

ContentHeader.propTypes = {
    onLogout: PropTypes.func.isRequired,
    onSidebarToggleCollapse: PropTypes.func.isRequired,
    onNotificationsLoad: PropTypes.func.isRequired,
    onTaskProgressLoad: PropTypes.func.isRequired,
    notifications: PropTypes.oneOfType([
        PropTypes.object.isRequired,
        PropTypes.array.isRequired,
    ]),
    tasksProgress: PropTypes.oneOfType([
        PropTypes.object.isRequired,
        PropTypes.array.isRequired,
    ]),
};

export default ContentHeader;


// WEBPACK FOOTER //
// ./src/components/Common/ContentHeader.js